export interface LoadingProps {
  className?: string;
  style?: {};
}

export const Loading = ({ className = "", ...props }: LoadingProps) => {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      {...props}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <strong>Loading...</strong>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          style={{
            margin: "auto",
            background: "0 0",
            display: "block",
            shapeRendering: "auto",
          }}
          width="80"
          height="80"
          viewBox="0 0 100 100"
          preserveAspectRatio="xMidYMid"
        >
          <rect
            x="38.5"
            y="25.5"
            rx="11.5"
            ry="4.5"
            width="23"
            height="9"
            fill="#84bd00"
          >
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.8s"
              repeatCount="indefinite"
            />
          </rect>
          <rect
            x="38.5"
            y="25.5"
            rx="11.5"
            ry="4.5"
            width="23"
            height="9"
            fill="#84bd00"
            transform="rotate(72 50 50)"
          >
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.6s"
              repeatCount="indefinite"
            />
          </rect>
          <rect
            x="38.5"
            y="25.5"
            rx="11.5"
            ry="4.5"
            width="23"
            height="9"
            fill="#84bd00"
            transform="rotate(144 50 50)"
          >
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.4s"
              repeatCount="indefinite"
            />
          </rect>
          <rect
            x="38.5"
            y="25.5"
            rx="11.5"
            ry="4.5"
            width="23"
            height="9"
            fill="#84bd00"
            transform="rotate(216 50 50)"
          >
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="-0.2s"
              repeatCount="indefinite"
            />
          </rect>
          <rect
            x="38.5"
            y="25.5"
            rx="11.5"
            ry="4.5"
            width="23"
            height="9"
            fill="#84bd00"
            transform="rotate(288 50 50)"
          >
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1s"
              begin="0s"
              repeatCount="indefinite"
            />
          </rect>
        </svg>
      </div>
    </div>
  );
};
